import { Timestamp } from 'firebase/firestore';

export const createClinicalSessionParams = (
  formState,
  goalsArray,
  quickTracksArray,
  user,
  sessionData
) => {
  // Convert time to ISO string if it's a dayjs object or Date
  let timeOfSession = '';
  if (formState.time) {
    // Check if it's a dayjs object (has $d property and dayjs methods)
    if (formState.time.$d && formState.time.$d instanceof Date && typeof formState.time.toISOString === 'function') {
      // It's a dayjs object
      timeOfSession = formState.time.toISOString();
    } else if (formState.time instanceof Date) {
      // It's a Date object
      timeOfSession = formState.time.toISOString();
    } else if (typeof formState.time === 'string') {
      // It's already a string (ISO or other format) - validate it's a valid date string
      const testDate = new Date(formState.time);
      if (!Number.isNaN(testDate.getTime())) {
        timeOfSession = formState.time;
      }
    } else if (typeof formState.time === 'object' && typeof formState.time.toISOString === 'function') {
      // It has a toISOString method
      try {
        timeOfSession = formState.time.toISOString();
      } catch (error) {
        console.warn('Failed to convert time to ISO string:', error);
      }
    }
  }

  // Convert endTime to ISO string if it's a dayjs object or Date
  let endTimeOfSession = '';
  if (formState.endTime) {
    // Check if it's a dayjs object (has $d property and dayjs methods)
    if (formState.endTime.$d && formState.endTime.$d instanceof Date && typeof formState.endTime.toISOString === 'function') {
      // It's a dayjs object
      endTimeOfSession = formState.endTime.toISOString();
    } else if (formState.endTime instanceof Date) {
      // It's a Date object
      endTimeOfSession = formState.endTime.toISOString();
    } else if (typeof formState.endTime === 'string') {
      // It's already a string (ISO or other format) - validate it's a valid date string
      const testDate = new Date(formState.endTime);
      if (!Number.isNaN(testDate.getTime())) {
        endTimeOfSession = formState.endTime;
      }
    } else if (typeof formState.endTime === 'object' && typeof formState.endTime.toISOString === 'function') {
      // It has a toISOString method
      try {
        endTimeOfSession = formState.endTime.toISOString();
      } catch (error) {
        console.warn('Failed to convert endTime to ISO string:', error);
      }
    }
  }

  return {
    StudentName: formState.studentName || '',
    StudentID: formState.studentId || '',
    ClinicalSessionAuthor: {
      ClinicianID:
        sessionData?.ClinicalSessionAuthor?.ClinicianID ||
        formState.clinicianId ||
        user?.uid ||
        '',
      ClinicianName:
        sessionData?.ClinicalSessionAuthor?.ClinicianName ||
        formState.clinicianName ||
        user?.displayName ||
        user?.name ||
        user?.fullname ||
        '',
      ClinicianNPI:
        sessionData?.ClinicalSessionAuthor?.ClinicianNPI ||
        formState.clinicianNpi ||
        user?.provider?.npi ||
        '',
    },
    ClinicalSessionDetails: {
      DateOfSession: formState.date || '',
      TimeOfSession: timeOfSession,
      EndTimeOfSession: endTimeOfSession,
      SessionLength: formState.sessionLength || '',
      CustomSessionLength: formState.customSessionLength || '',
      SessionAttended: formState.sessionAttended || '',
      Setting: formState.setting || '',
      CustomSetting: formState.customSetting || '',
      GroupSize:
        formState.groupSize === 'Other' && formState.customGroupSize
          ? `Group of ${formState.customGroupSize}`
          : formState.groupSize || '',
      CustomGroupSize: formState.customGroupSize || '',
      GroupType: formState.groupType || '',
      CustomGroupType: formState.customGroupType || '',
      AbsentReason: formState.absentReason || '',
      CustomAbsentReason: formState.customAbsentReason || '',
      AbsentNotes: formState.absentNotes || '',
      SessionType: formState.sessionType || '',
      CustomSessionType: formState.customSessionType || '',
    },
    SessionSummary: formState.sessionSummary || '',
    Observations: formState.observations || '',
    BillingInformation: {
      IsBillable: formState.isBillable || false,
      CPTCodes: formState.cptCodes || [],
      SDPServiceCodes: formState.sdpServiceCodes || [],
      IEPServiceTherapies: formState.iepServiceTherapies || [],
      NonBillableReason: formState.nonBillableReason || '',
    },
    Goals: goalsArray, //array in [{goalID: goalId, dataEntryID: dataEntryId}] format
    QuickTracks: quickTracksArray, //array in [{quickTrackID: quickTrackId, dataEntryID: dataEntryId}] format
    ShareWithTeam: {
      EditAccess: formState.editAccess || [],
      ViewOnlyAccess: formState.viewOnlyAccess || [],
    },
    createdAt: Timestamp.now(),
  };
};